import { create } from 'zustand';

export type ViewedRowList =
  | 'specimens'
  | 'specimenZms'
  | 'promoItems'
  | 'promoItemZms'
  | 'zonalStatementZms'
  | 'systemDashboardMembers'
  | 'dcrDashboardZms'
  | 'questionMonitorBoards'
  | 'questionMonitorMembers'
  | 'questionMonitorClasses'
  | 'questionMonitorDistricts'
  | 'questionMonitorInstitutes'
  | 'questionInstitutePapers'
  | 'publishBatches'
  | 'donationCandidates'
  | 'donationBatches'
  | 'donations'
  | 'donationRegions'
  | 'donationProjects'
  | 'feedbacks'
  | 'surveys'
  | 'surveySubmissions'
  | 'leaveApplications'
  | 'teacherInactivations';

interface ViewedRow {
  rowId: number;
  parentId: number | null;
}

interface LastViewedRowState {
  viewedRowByList: Partial<Record<ViewedRowList, ViewedRow>>;
  rememberViewedRow: (list: ViewedRowList, viewedRow: ViewedRow) => void;
}

export const useLastViewedRowStore = create<LastViewedRowState>((set) => ({
  viewedRowByList: {},
  rememberViewedRow: (list, viewedRow) =>
    set((state) => ({ viewedRowByList: { ...state.viewedRowByList, [list]: viewedRow } })),
}));
